import { render, staticRenderFns } from "./ProfileTemplate.vue?vue&type=template&id=38a332a0&"
import script from "./ProfileTemplate.vue?vue&type=script&lang=js&"
export * from "./ProfileTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTemplate.vue?vue&type=style&index=0&id=38a332a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports